/** **********************************
 * 2021.11.11 新用户中心接口 POST  *******
 * ***********************************
 * */ 

import { SERVER_DOMAIN, PROTO_MODULE,EX_DOMAIN,AISERVICE_DOMAIN } from '../constant'
import request from '../requestPB'
import requestJSON from '../requestJSON'

// 用户验证码请求     /api/v1/account/sendSmsCode
export const psVerify = (data) => {
  return request({
    url: `${SERVER_DOMAIN}/aiservice/psVerify/verify`,
    method: 'POST',
    data,
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSPsAppraisalPSVerifyRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSPsAppraisalPSVerifyResponse',
    ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true
  })
}

export const vehicleDamage = (data) => {
  console.log(EX_DOMAIN);
  return request({
    url: `${EX_DOMAIN}/api/v1/vehicle_damage/check`,
    method: 'POST',
    data,
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.VehicleDamageCheckRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.VehicleDamageCheckResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'ex',
    TOKEN_REQUIRED: true
  })
}

export const upload = (data) => {
  return requestJSON({
    url: `${AISERVICE_DOMAIN}/vehdamage/v1/commit`,
    method: 'POST',
    data,
  }, {
    TOKEN_REQUIRED: true
  })
}
